/* eslint-disable @typescript-eslint/restrict-plus-operands */
import styled from 'styled-components';

export const Container = styled.div<{theme?: any; clear?: boolean}>`
  width: 100%;
  background-color: ${({theme, clear}) =>
    clear ? 'transparent' : theme.white};
  padding: ${({clear}) => (clear ? '0px 5px' : '22px 20px')};
  display: flex;
  border: ${({theme, clear}) =>
    clear ? '0px' : '1px solid ' + theme.grayBorder};
  text-align: center;
  border-radius: 8px;
  box-shadow: ${({theme, clear}) =>
    clear ? '0px 0px 0px' : '0px 4px 12px' + theme.cardshadow};
  box-sizing: border-box;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const Label = styled.text<{theme?: any; color?: string}>`
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: ${({theme, color}) => color || theme.darkGrayText};
`;

export const Value = styled.text<{
  theme?: any;
  valueSize?: string;
  color?: string;
}>`
  font-weight: bold;
  font-size: ${({valueSize}) => valueSize || '40px'};
  line-height: 47px;
  color: ${({theme, color}) => color || theme.secondary};
`;
